export function animation() {

  // 関数定義
  var inviewAction = function(content, classname) {
      var contentTopFade = Math.floor(content.getBoundingClientRect().top + window.scrollY);
      var visibilHeight = window.innerHeight + window.scrollY;
      if (contentTopFade <= visibilHeight) {
          content.classList.add(classname);
      }
  };

  // 対象のコンテンツの表示(時間差)
  var inviewActionLate = function(content, classname, time) {
      var contentTopFade = Math.floor(content.getBoundingClientRect().top + window.scrollY);
      var visibilHeight = window.innerHeight + window.scrollY;
      if (contentTopFade <= visibilHeight) {
          setTimeout(function() {
              content.classList.add(classname);
          }, time);
      }
  };

  // 全てのクラスに対してアニメーションを適用する関数
  var applyAnimations = function() {
      document.querySelectorAll('.inview').forEach(function(element) {
          inviewAction(element, 'inview_action');
      });

      document.querySelectorAll('.bounceInUp').forEach(function(element) {
        inviewAction(element, 'go');
      });

      document.querySelectorAll('.bounceInUp200').forEach(function(element) {
        inviewActionLate(element, 'go', 200);
      });
    
      document.querySelectorAll('.bounceInUp400').forEach(function(element) {
        inviewActionLate(element, 'go', 400);
      });
    
      document.querySelectorAll('.bounceInUp600').forEach(function(element) {
        inviewActionLate(element, 'go', 600);
      });
    
      document.querySelectorAll('.bounceInUp800').forEach(function(element) {
        inviewActionLate(element, 'go', 800);
      });

      document.querySelectorAll('.inview_up').forEach(function(element) {
          inviewAction(element, 'inview_up_action');
      });

      document.querySelectorAll('.inview_left').forEach(function(element) {
          inviewAction(element, 'inview_left_action');
      });

      document.querySelectorAll('.inview_right').forEach(function(element) {
          inviewAction(element, 'inview_right_action');
      });

      document.querySelectorAll('.p-scholarship__detail__bu').forEach(function(element) {
          inviewAction(element, 'active');
      });

      document.querySelectorAll('.p-scholarship__detail__bu__wrap').forEach(function(element) {
          inviewAction(element, 'active');
      });

      document.querySelectorAll('.inview200').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 200);
      });

      document.querySelectorAll('.inview300').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 300);
      });

      document.querySelectorAll('.inview400').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 400);
      });

      document.querySelectorAll('.inview500').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 500);
      });

      document.querySelectorAll('.inview600').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 600);
      });

      document.querySelectorAll('.inview700').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 700);
      });

      document.querySelectorAll('.inview800').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 800);
      });

      document.querySelectorAll('.inview900').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 900);
      });

      document.querySelectorAll('.inview1000').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1000);
      });

      document.querySelectorAll('.inview1100').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1100);
      });

      document.querySelectorAll('.inview1200').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1200);
      });

      document.querySelectorAll('.inview1300').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1300);
      });

      document.querySelectorAll('.inview1400').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1400);
      });

      document.querySelectorAll('.inview1500').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1500);
      });

      document.querySelectorAll('.inview1600').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1600);
      });

      document.querySelectorAll('.inview1700').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1700);
      });

      document.querySelectorAll('.inview1800').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1800);
      });

      document.querySelectorAll('.inview1900').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 1900);
      });

      document.querySelectorAll('.inview2000').forEach(function(element) {
          inviewActionLate(element, 'inview_action', 2000);
      });

      document.querySelectorAll('.inview_up200').forEach(function(element) {
          inviewActionLate(element, 'inview_up_action', 200);
      });

      document.querySelectorAll('.inview_up300').forEach(function(element) {
          inviewActionLate(element, 'inview_up_action', 300);
      });

      document.querySelectorAll('.inview_up400').forEach(function(element) {
          inviewActionLate(element, 'inview_up_action', 400);
      });

      document.querySelectorAll('.inview_up500').forEach(function(element) {
          inviewActionLate(element, 'inview_up_action', 500);
      });

      document.querySelectorAll('.inview_up600').forEach(function(element) {
          inviewActionLate(element, 'inview_up_action', 600);
      });

      document.querySelectorAll('.inview_up700').forEach(function(element) {
          inviewActionLate(element, 'inview_up_action', 700);
      });

      document.querySelectorAll('.inview_up900').forEach(function(element) {
          inviewActionLate(element, 'inview_up_action', 900);
      });

      document.querySelectorAll('.inview_up1200').forEach(function(element) {
          inviewActionLate(element, 'inview_up_action', 1200);
      });

      document.querySelectorAll('.inview_left200').forEach(function(element) {
          inviewActionLate(element, 'inview_left_action', 200);
      });

      document.querySelectorAll('.inview_left300').forEach(function(element) {
          inviewActionLate(element, 'inview_left_action', 300);
      });

      document.querySelectorAll('.inview_left400').forEach(function(element) {
          inviewActionLate(element, 'inview_left_action', 400);
      });

      document.querySelectorAll('.inview_left500').forEach(function(element) {
          inviewActionLate(element, 'inview_left_action', 500);
      });

      document.querySelectorAll('.inview_left600').forEach(function(element) {
          inviewActionLate(element, 'inview_left_action', 600);
      });

      document.querySelectorAll('.inview_left700').forEach(function(element) {
          inviewActionLate(element, 'inview_left_action', 700);
      });

      document.querySelectorAll('.inview_left900').forEach(function(element) {
          inviewActionLate(element, 'inview_left_action', 900);
      });

      document.querySelectorAll('.inview_left1200').forEach(function(element) {
          inviewActionLate(element, 'inview_left_action', 1200);
      });

      document.querySelectorAll('.inview_right200').forEach(function(element) {
          inviewActionLate(element, 'inview_right_action', 200);
      });

      document.querySelectorAll('.inview_right300').forEach(function(element) {
          inviewActionLate(element, 'inview_right_action', 300);
      });

      document.querySelectorAll('.inview_right400').forEach(function(element) {
          inviewActionLate(element, 'inview_right_action', 400);
      });

      document.querySelectorAll('.inview_right500').forEach(function(element) {
          inviewActionLate(element, 'inview_right_action', 500);
      });

      document.querySelectorAll('.inview_right600').forEach(function(element) {
          inviewActionLate(element, 'inview_right_action', 600);
      });

      document.querySelectorAll('.inview_right700').forEach(function(element) {
          inviewActionLate(element, 'inview_right_action', 700);
      });

      document.querySelectorAll('.inview_right900').forEach(function(element) {
          inviewActionLate(element, 'inview_right_action', 900);
      });

      document.querySelectorAll('.inview_right1200').forEach(function(element) {
          inviewActionLate(element, 'inview_right_action', 1200);
      });

      document.querySelectorAll('.zoom').forEach(function(element) {
          inviewActionLate(element, 'is-animated', 100);
      });

      document.querySelectorAll('.zoom2').forEach(function(element) {
          inviewActionLate(element, 'is-animated', 400);
      });

      document.querySelectorAll('.zoom3').forEach(function(element) {
          inviewActionLate(element, 'is-animated', 700);
      });
  };

  // ページロード時とスクロール時にアニメーションを適用
  window.addEventListener('DOMContentLoaded', applyAnimations);
  window.addEventListener('scroll', applyAnimations);
}